import {
  set,
} from 'lodash';
import {
  AnalyticsContext,
} from '@gcc/adobe-analytics';
import { sites } from '../../../react/estimateBuilder/helpers/globalVariables';

define([
  "globals",
  "base-view-model",
  "helpers",
  "jquery",
  "knockout",
  "underscore",
  "postal",
  "measure-and-install",
  "local-storage",
  "cookies-factory",
  "product-price-view-model",
  "product-estimate-price-view-model",
  "product-estimate-price-post-measure-view-model",
  "product-gallery-view-model",
  "feature!product-reviews",
  "cookies-factory",
  "scroll-to-section",
  "es6-promise"
], function (
  globals,
  baseViewModel,
  helpers,
  $,
  ko,
  _,
  postal,
  MandiVM,
  LocalStorage,
  CookiesFactory,
  ProductPriceViewModel,
  EstimateProductPriceViewModel,
  EstimateProductPricePostMeasureViewModel,
  ProductGalleryViewModel,
  ProductReviews,
  cookiesFactory,
  scroll
) {
  var SetLocalStorageAndCookieToPersist = function () {
    var localStorage = new LocalStorage();
    var widthWhole = $("#SelectedWidth").val();
    var widthEigth = $("#SelectedWidthEigth").val();
    var heightWhole = $("#SelectedHeight").val();
    var heightEigth = $("#SelectedHeightEigth").val();

    if (widthEigth == undefined) {
      widthEigth = 0;
    }
    if (heightEigth == undefined) {
      heightEigth = 0;
    }

    var width = parseFloat(widthWhole) + parseFloat(widthEigth / 8);
    var height = parseFloat(heightWhole) + parseFloat(heightEigth / 8);

    var minWidth = $("#SelectedWidth option:first").val();
    var maxWidth = $("#SelectedWidth option:last").val();
    var minHeight = $("#SelectedHeight option:first").val();
    var maxHeight = $("#SelectedHeight option:last").val();

    var widthStorage = {
      LocalStoragePersister: {},
      minDimension: minWidth,
      maxDimension: maxWidth,
      serializableValue: width,
      getDimensionsEighths: [{ name: "0/0", value: 0 }, { name: "1/8", value: 1 }, { name: "1/4", value: 2 }, { name: "3/8", value: 3 }, { name: "1/2", value: 4 }, { name: "5/8", value: 5 }, { name: "3/4", value: 6 }, { name: "7/8", value: 7 }]
    };
    var heightStorage = {
      LocalStoragePersister: {},
      minDimension: minWidth,
      maxDimension: maxWidth,
      serializableValue: height,
      getDimensionsEighths: [{ name: "0/0", value: 0 }, { name: "1/8", value: 1 }, { name: "1/4", value: 2 }, { name: "3/8", value: 3 }, { name: "1/2", value: 4 }, { name: "5/8", value: 5 }, { name: "3/4", value: 6 }, { name: "7/8", value: 7 }]
    };

    localStorage.persist("SELECTED_WIDTH_STORAGE_KEY", widthStorage);
    localStorage.persist("SELECTED_HEIGHT_STORAGE_KEY", heightStorage);
    Cookies.set("widthz", width);
    Cookies.set("hghtz", height);
  };

  var ProductViewModel = function () {
    var self = this;
    ko.utils.extend(self, baseViewModel);
    self.isInternalUser = cookiesFactory.isInternalUser();
    var siteProductMedia;
    var MAIN_IMAGE_QUERY_STRING_PARAMS =
      "?quality=90&mode=crop&anchor=middlecenter&width=400&height=400&";

    self.isMobile = ko.computed(function () {
      var isMobile = globals.ssm
        .getState("mobile")
        .options.observableIsActive();
      return isMobile;
    });

    self.hasMeasureInstallInstructionLink = ko.computed(function () {
      if ($("#site-product-quick-links ul li > a:first")[0] === undefined)
        return false;
      var measureInstallLink = $("#site-product-quick-links ul li > a:first")[0]
        .href;
      return measureInstallLink !== "";
    });

    if (globals.siteId === 11) {
      self.mandiVM = new MandiVM(
        globals.paths.measureAndInstallDomain,
        true,
        globals.isProfessionallyInstallable
      );
    }

    self.mainImage = ko.observable();
    self.previewGallery = null;
    self.productDescription = ko.observable();
    self.shortDescription = ko.observable();
    self.productName = ko.observable();
    self.promoDescription = ko.observable();
    self.pricingSubmodel = ko.observable();
    self.dictionary = ko.observable();
    self.hideDetails = ko.observable(self.isMobile());
    self.showProductSpecificationsHeader = ko.observable(self.isMobile());
    self.hideSpecifications = ko.observable(self.isMobile());
    self.aliasId = globals.aliasId;

    var productReviews = new ProductReviews(globals.productId, globals.aliasId);
    self.reviews = ko.observable(productReviews);

    ko.applyBindings(self.reviews(), $(".bdc-product-customer-reviews")[0]);

    self.vendorName = ko.observable();

    if (self.isInternalUser === true) {
      $.get(globals.paths.internalInfo, {
        productId: globals.productId,
        siteId: globals.siteId
      })
        .done(function (data) {
          self.vendorName(data.VendorName);
        })
        .fail(function () {
          self.vendorName("");
        });
    }

    var channel = postal.channel("productpage");

    channel.subscribe("product.customize", function () {
      self.customize();
    });

    channel.subscribe("show.main.gallery", function (currentThumbnailId) {
      const $allPhotoThumbnails = $(".gcc-product-gallery-thumbnails-photo").find("img");
      $(".bdc-current-video-caption").hide();
      $allPhotoThumbnails.colorbox({
        transition: "none",
        inline: true,
        width: "900px",
        close: "",
        height: "595px",
        href: "#gcc-product-gallery-detail",
        onClosed: function () {
          $("#gcc-product-gallery-detail").hide();
        },
        onCleanup: function () {
          $("#gcc-product-gallery-detail").hide();
          $("#bcVideoPlayerWrapper-Modal").empty();
        }
      });
      $($allPhotoThumbnails.get(0)).trigger("click");
      self.previewGallery.changeImageById(currentThumbnailId);
      $("#gcc-product-gallery-detail").show();
    });

    self.changeMainImage = function (data) {
      self.mainImage(data.media.Url);
    };

    self.toggleDetails = function (shouldOnlyShow) {
      if (shouldOnlyShow !== undefined && shouldOnlyShow === "true") {
        self.hideDetails(false);
        if (globals.siteId === 3) {
          scroll("#bdc-product-details");
        }
      } else {
        self.hideDetails(!self.hideDetails());
      }
    };

    self.toggleSpecifications = function () {
      self.hideSpecifications(!self.hideSpecifications());
    };

    self.changeHomeImage = function () {
      self.mainImage();
    };

    self.customize = function () {
      if (globals.siteId == '1') {
        SetLocalStorageAndCookieToPersist();

        let path = globals.paths.productConfigurator;
        path += window.location.href.indexOf('utm_medium=pla') > 0 ? "&pla=true" : "";
        window.location = path;
      }
      else {
        let path = globals.paths.productConfigurator;
        window.location = path;
      }
    };

    self.applyPreviewGalleryBindings = function () {
      if ($(".bdc-product-slideshow").length > 0) {
        ko.applyBindings(self.previewGallery, $(".bdc-product-slideshow")[0]);
      }
      if (globals.ssm.getState("tablet").active || globals.isIE9) {
        if ($(".bdc-product-slideshow-thumbnails-container").length > 0) {
          ko.applyBindings(
            self.previewGallery,
            $(".bdc-product-slideshow-thumbnails-container")[0]
          );
        }
        if ($(".bdc-product-image-see-more").length > 0) {
          ko.applyBindings(
            self.previewGallery,
            $(".bdc-product-image-see-more")[0]
          );
          ko.applyBindings(
            self.previewGallery,
            $("#gcc-product-gallery-detail")[0]
          );
        }
      }
    };

    self.hasVideos = ko.observable(false);

    self.shouldShowVideosTab = ko.observable(false);

    self.showVideo = function () {
      self.previewGallery.showVideo(self.previewGallery.videos()[0]);
      return true;
    };

    self.stopVideos = function() {
      $("#bcVideoPlayerWrapper-Gallery").empty();
      return true;
    };

    var load = function () {
      siteProductMedia = globals.models.mediaGallery;
      if (window.pageContextJavascript.useReactGallery !== true) {
        self.previewGallery = new ProductGalleryViewModel(
          globals.models.mediaGallery,
          MAIN_IMAGE_QUERY_STRING_PARAMS
        );

        self.applyPreviewGalleryBindings();

        self.previewGallery.hasVideos.subscribe(function (v) {
          self.hasVideos(v);
        });
        self.previewGallery.shouldShowVideosTab.subscribe(function (v) {
          self.shouldShowVideosTab(v);
        });
        self.previewGallery.startSlideshow();
      }

      var productDetails = globals.models.productDetails;
      self.productDescription(productDetails.ProductDescription);
      self.shortDescription(productDetails.ShortDescription);
      try {
        self.productName(window.digitalData.product[0].productInfo.productName);
      } catch (e) { }
      self.promoDescription(
        escapeLineBreak(productDetails.PromoDescription) || null
      );
      var productPrice;
      if (globals.estimateMode === true) {
        if (globals.pageType === 5) {
          productPrice = new EstimateProductPricePostMeasureViewModel(self, {
            minWidth: productDetails.Dimensions.MinWidth,
            maxWidth: productDetails.Dimensions.MaxWidth,
            minHeight: productDetails.Dimensions.MinHeight,
            maxHeight: productDetails.Dimensions.MaxHeight
          });
        } else {
          productPrice = new EstimateProductPriceViewModel(self, {
            minWidth: productDetails.Dimensions.MinWidth,
            maxWidth: productDetails.Dimensions.MaxWidth,
            minHeight: productDetails.Dimensions.MinHeight,
            maxHeight: productDetails.Dimensions.MaxHeight
          });
        }
      } else {
        productPrice = new ProductPriceViewModel(self, {
          minWidth: productDetails.Dimensions.MinWidth,
          maxWidth: productDetails.Dimensions.MaxWidth,
          minHeight: productDetails.Dimensions.MinHeight,
          maxHeight: productDetails.Dimensions.MaxHeight
        });

        // initial price for sticky header
        var initialPriceEvent = new CustomEvent("price-loaded", {
          detail: {
            price: productPrice.discountPrice(),
          }
        });
        dispatchEvent(initialPriceEvent);
      }

      self.pricingSubmodel(productPrice);

      ko.applyBindings(self, $(".bdc-product")[0]);

      if (globals.estimateMode !== true) {
        productPrice.updateWholeEighths(
          self.pricingSubmodel(),
          $(".gcc-dimension-whole")
        );
      }

      if (location.hash === "#bdc-product-details") {
        self.hideDetails(false);
      }
    };

    self.init = function () {
      return load();
    };

    self.loadReviews = function () {
      productReviews.getReviewData(function (numReviews) {
        self.reviews().numReviews(numReviews);
      });
    };

    self.scrollToSureFitGuaranteedToFit = function () {
      if (this.hideDetails()) {
        this.toggleDetails();
      }
      if ($(".bdc-product-details .bdc-surefit").length > 0) {
        scroll(".bdc-product-details .bdc-surefit");
      } else if (
        $(".bdc-product-details .bdc-font-guaranteed-to-fit").length > 0
      ) {
        scroll(".bdc-product-details .bdc-font-guaranteed-to-fit");
      }
    };

    self.scrollToSection = function (hash) {
      scroll(hash);
    };
    var escapeLineBreak = function (input) {
      if (input !== null) {
        return input.replace(/\/n/gi, "");
      } else {
        return null;
      }
    };
  };

  if (globals.siteId === sites.americanBlinds) {
    var groupAGuide = ['bamboo shades', 'cellular shades', 'fabric blinds', 'faux wood blinds', 'mini blinds', 'pleated shades', 'roman shades', 'vinyl blinds', 'wood blinds'];
    var groupBGuide = ['dual sheer shades', 'outdoor shades', 'roller shades', 'sheer shades', 'solar shades'];
    var groupCGuide = ['panel track blinds', 'sheer vertical blinds', 'sheer vertical shades', 'vertical blinds', 'vertical cellular shades'];
    var prodCat = '';
    try {
      prodCat = window.digitalData.product[0].productInfo.productCategory;
    } catch (e) { }
    if ($.inArray(prodCat, groupAGuide) !== -1) {
      $(".gcc-measure-guide-w").css("background-image", "url(//media.blinds.com/infopages/images/measure-guide/group-a-width.png)");
      $(".gcc-measure-guide-h").css("background-image", "url(//media.blinds.com/infopages/images/measure-guide/group-a-height.png)");
    } else if ($.inArray(prodCat, groupBGuide) !== -1) {
      $(".gcc-measure-guide-w").css("background-image", "url(//media.blinds.com/infopages/images/measure-guide/group-b-width.png)");
      $(".gcc-measure-guide-h").css("background-image", "url(//media.blinds.com/infopages/images/measure-guide/group-b-height.png)");
    } else if ($.inArray(prodCat, groupCGuide) !== -1) {
      $(".gcc-measure-guide-w").css("background-image", "url(//media.blinds.com/infopages/images/measure-guide/group-c-width.png)");
      $(".gcc-measure-guide-h").css("background-image", "url(//media.blinds.com/infopages/images/measure-guide/group-c-height.png)");
    }

    if ($(".gcc-measure-guide-w").css("background-image") != "none") {
      $(document).on("mouseenter mouseleave", ".gcc-prd-prcupd-w", function (e) {
        if (e.type == "mouseenter") {
          $(".gcc-measure-guide-w").css({ "width": $(".gcc-prd-media").width(), "height": $(".gcc-prd-media").height() });
          $(".gcc-measure-guide-w").show();
          $(".gcc-product-gallery").css("display", "none");
        } else {
          $(".gcc-measure-guide-w").hide();
          $(".gcc-product-gallery").css("display", "block");
        }
      });

      $(document).on("mouseenter mouseleave", ".gcc-prd-prcupd-h", function (e) {
        if (e.type == "mouseenter") {
          $(".gcc-measure-guide-h").css({ "width": $(".gcc-prd-media").width(), "height": $(".gcc-prd-media").height() });
          $(".gcc-measure-guide-h").show();
          $(".gcc-product-gallery").css("display", "none");
        } else {
          $(".gcc-measure-guide-h").hide();
          $(".gcc-product-gallery").css("display", "block");
        }
      });
    }
  }

  $(function () {
    $("#gcc-product-gallery-type-photos").prop("checked", true);
    if ($("#site-product-quick-links ul li > a:first")[0] !== undefined) {
      $("#bdc-product-measure-install-instructions").show();
      $("#bdc-product-measure-install-instructions").click(function () {
        scroll("#site-product-quick-links");
      });
    }
    // Scroll to Section
    if (location.hash !== "") {
      try {
        var element = $.find(location.hash);
        if (element.length > 0) {
          scroll(location.hash);
        }
      } catch (e) { }
    }
  });

  // The server sets some properties for the page and site objects, so we are just grabbing them
  // and setting the experienceType, and then fire the page load event.
  if (globals.siteId === sites.theHomeDepot || globals.siteId === sites.blinds) {
    const analyticsContext = new AnalyticsContext(globals.siteId);
    const pageObject = window.digitalData.page;
    const siteObject = window.digitalData.site;
    set(siteObject, 'experienceType', window.device.type);
    set(siteObject, 'siteId', globals.siteId);
    analyticsContext.sendPageLoadEvent(pageObject, siteObject);
  }

  return ProductViewModel;
});
